"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateForm = exports.validateRequired = exports.validatePhone = exports.validateEmail = exports.validateErpRestrictedCharacters = exports.validatePattern = exports.validateAllowedCharacters = void 0;

var __1 = require("..");

var __2 = require("..");

var validateAllowedCharacters = function validateAllowedCharacters(value, pattern) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __1.Language.en;
  var errorMessage = "";
  var regex = new RegExp(pattern, "gi");

  if (value && value.match(regex) === null) {
    errorMessage = __2.CONSTANTS[language].PATTERN_INVALID;
  }

  return errorMessage;
};

exports.validateAllowedCharacters = validateAllowedCharacters;

var validatePattern = function validatePattern(value, pattern) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __1.Language.en;
  var errorMessage = "";
  var regex = new RegExp(pattern);

  if (value && !regex.test(value)) {
    errorMessage = __2.CONSTANTS[language].PATTERN_INVALID;
  }

  return errorMessage;
};

exports.validatePattern = validatePattern;

var validateErpRestrictedCharacters = function validateErpRestrictedCharacters(value) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __1.Language.en;
  var errorMessage = "";
  var regex = new RegExp(/['‘’<>&"“”]/g);

  if (value && regex.test(value)) {
    errorMessage = __2.CONSTANTS[language].ERP_RESTRICTED_CHARACTERS;
  }

  return errorMessage;
};

exports.validateErpRestrictedCharacters = validateErpRestrictedCharacters;

var validateEmail = function validateEmail(value, isRequired) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __1.Language.en;
  var error = "";

  if (!value && isRequired) {
    error = __2.CONSTANTS[language].REQUIRED_FIELD;
  } else if (value && !/\S+@\S+\.\S+/.test(value)) {
    error = __2.CONSTANTS[language].EMAIL_INVALID;
  }

  return error;
};

exports.validateEmail = validateEmail;

var validatePhone = function validatePhone(value, isRequired) {
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __1.Language.en;
  var error = "";
  var allowCountryCodes = ["+1", "+52"];

  if (!value && isRequired) {
    error = __2.CONSTANTS[language].REQUIRED_FIELD;
  } else if (value.length === 10 && value.startsWith("0") || value.length === 12 && !value.includes(allowCountryCodes[0]) || value.length === 13 && !value.includes(allowCountryCodes[1]) || value && !value.match(/^(\+\d{1,3}?)?\d{10}$/)) {
    error = __2.CONSTANTS[language].PHONE_INVALID;
  }

  return error;
};

exports.validatePhone = validatePhone;

var validateRequired = function validateRequired(value) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __1.Language.en;
  var errorMessage = "";

  if (!!value && typeof value === "string") {
    errorMessage = value.trim().length === 0 ? __2.CONSTANTS[language].REQUIRED_FIELD : "";
  } else {
    errorMessage = !!value ? "" : __2.CONSTANTS[language].REQUIRED_FIELD;
  }

  return errorMessage;
};

exports.validateRequired = validateRequired;

var validateForm = function validateForm(form) {
  var isValid = true;

  if (form) {
    for (var field in form) {
      if (form[field]) {
        isValid = false;
        break;
      }
    }
  }

  return isValid;
};

exports.validateForm = validateForm;
var ValidationUtilities = {
  validateAllowedCharacters: exports.validateAllowedCharacters,
  validatePattern: exports.validatePattern,
  validateErpRestrictedCharacters: exports.validateErpRestrictedCharacters,
  validateEmail: exports.validateEmail,
  validatePhone: exports.validatePhone,
  validateRequired: exports.validateRequired,
  validateForm: exports.validateForm
};
exports.default = ValidationUtilities;